import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Sidebar extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    network: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    dirty: PropTypes.bool,
    onChange: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return (
      <div className="maha-signup-page-designer-sidebar">
        <Form { ...this._getForm() } />
      </div>
    )
  }

  _getForm() {
    const { config, dirty, onChange, onSave } = this.props
    return {
      ref: this.formRef,
      title: 't(Signup Page)',
      cancelText: null,
      saveText: null,
      onChange,
      onSuccess: this._handleSuccess,
      ...onSave ? {
        buttons: [
          { 
            label: 't(Save)', 
            color: 'blue', 
            disabled: !dirty, 
            handler: this._handleSubmit 
          }
        ]
      } : {},
      sections: [
        {
          fields: [
            { 
              label: 't(Name)', 
              name: 'name', 
              type: 'textfiueld', 
              required: true,
              value: config?.name
            },
            { 
              label: 't(Personal Message)', 
              name: 'message', 
              type: 'htmlfield', 
              required: true,
              value: config?.message
            },
            {
              label: 't(Headshot)',
              name: 'headshot',
              type: 'mediafield',
              ratio: 1,
              multiple: false,
              value: config?.headshot
            }
          ]
        }
      ]
    }
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    this.props.onSave(config)
  }

}

export default Sidebar
